<template>
  <div class="section">
    <div class="container">
      <div class="col-md-12">
        <h2 class="title text-center ultimas-noticias-title">Últimas noticias</h2>
        <div class="blogs-1" id="blogs-1">
          <div class="row">
            <div class="col-md-10 ml-auto mr-auto">
              <card class="card-noticia" v-show="post1" type="blog" plain>
                <template slot="raw-content">
                  <div class="row">
                    <div class="col-md-5">
                      <div class="card-image">
                        <img class="img img-raised rounded" :src="post1.thumbImageUrl" alt>
                      </div>
                    </div>
                    <div class="col-md-7">
                      <!-- <h6 class="category text-info">Enterprise</h6> -->
                      <h3 class="card-title">
                        <!-- <a href="#" @click="goPost1()">{{post1.title}}</a> -->
                        <a :href="post1.postEntryUrl">{{post1.title}}</a>
                      </h3>
                      <p class="card-description">{{post1.content}}</p>
                      <p class="author">{{post1.daysPassed}}</p>
                    </div>
                  </div>
                </template>
              </card>

              <card v-show="post2" type="blog" plain>
                <div class="row">
                  <div class="col-md-7">
                    <!-- <h6 class="category text-danger">
                      <i class="now-ui-icons now-ui-icons media-2_sound-wave"></i> Startup
                    </h6>-->
                    <h3 class="card-title">
                      <!-- <a href="#" @click="goPost2()">{{post2.title}}</a> -->
                      <a :href="post2.postEntryUrl">{{post2.title}}</a>
                    </h3>
                    <p class="card-description">{{post2.content}}</p>

                    <p class="author">{{post2.daysPassed}}</p>
                  </div>
                  <div class="col-md-5">
                    <div class="card-image">
                      <img class="img img-raised rounded" :src="post2.thumbImageUrl">
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Tabs, TabPane } from "@/components";

export default {
  name: "ultimas-noticias",
  components: { Card },
  data() {
    return {
      post1: {},
      post2: {}
    };
  },
  async mounted() {
    await this.load();
  },
  watch: {
    async "$route.params.postName"(oldParam, newParam) {
      await this.load();
    }
  },
  methods: {
    load: async function() {
      var uuid = this.getUuid(this.$route.params.postName);
      try {
        let response = await this.$zaiq().get("Noticia/Lastest", {
          params: {
            take: 2,
            except: uuid
          }
        });

        let list = response.data.result.items;
        if (list[0]) {
          this.post1 = list[0];
        }

        if (list[1]) {
          this.post2 = list[1];
        }
      } catch (e) {
        if (this.vErrors) this.vErrors.items.push(e);
        console.log(e);
      }
    },
    getUuid: function(postName /* aqui ira el friendly url name del post */) {
      return postName;
    },
    goPost1: function() {
      var x = {
        name: "post",
        params: { postName: this.post1.uuid }
      };
      this.$router.push(x);
    },
    goPost2: function() {
      var x = {
        name: "post",
        params: { postName: this.post2.uuid }
      };
      this.$router.push(x);
    }
  }
};
</script>
<style scoped>
div.section {
  padding-top: 0;
}

div.blogs-1 {
  padding-top: 0;
}

h2.ultimas-noticias-title {
  margin-bottom: 15px;
}

/* div.card .card-noticia .card-plain .card-blog {
  margin-bottom: 0px;
} */

.blogs-1 .card {
  margin-bottom: 0px;
}
</style>